var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrackTheSafeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 286.16 47.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#000;stroke-width:.62px;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-3{fill:#231815;}.cls-3,.cls-4,.cls-5{stroke-width:0px;}.cls-2{stroke:#fff;}.cls-4{fill:#9fa0a0;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.16,6.89c-9.19-9.19-24.08-9.19-33.27,0s-9.19,24.08,0,33.27c9.19,9.19,24.08,9.19,33.27,0,9.19-9.19,9.19-24.08,0-33.27ZM13.52,33.53c-5.52-5.52-5.52-14.48,0-20.01,5.53-5.53,14.48-5.52,20.01,0,5.53,5.53,5.53,14.48,0,20.01-5.52,5.52-14.48,5.53-20.01,0Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "40.3 9.17 36.75 10.58 38.16 7.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "40.2 9.07 36.64 10.48 38.05 6.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.46,
    y: 0.98,
    width: 0.18,
    height: 4.13,
    transform: "translate(-.08 .68) rotate(-1.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.37,
    y: 0.98,
    width: 0.18,
    height: 4.13,
    transform: "translate(-.08 .68) rotate(-1.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.78,
    y: 21.43,
    width: 0.18,
    height: 4.13,
    transform: "translate(68.63 -19.67) rotate(91.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 43.78,
    y: 21.34,
    width: 0.18,
    height: 4.13,
    transform: "translate(68.54 -19.76) rotate(91.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.02,
    y: 21.42,
    width: 0.18,
    height: 4.13,
    transform: "translate(26.68 21.06) rotate(91.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.03,
    y: 21.33,
    width: 0.18,
    height: 4.13,
    transform: "translate(26.59 20.97) rotate(91.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.45,
    y: 41.76,
    width: 0.18,
    height: 4.13,
    transform: "translate(-1.26 .7) rotate(-1.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.36,
    y: 41.76,
    width: 0.18,
    height: 4.13,
    transform: "translate(-1.26 .7) rotate(-1.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.12,
    y: 36.02,
    width: 0.18,
    height: 4.13,
    transform: "translate(29.63 4.64) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.06,
    y: 35.95,
    width: 0.18,
    height: 4.13,
    transform: "translate(29.56 4.67) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.13,
    y: 7.35,
    width: 0.21,
    height: 4.13,
    transform: "translate(-3.96 9.29) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.06,
    y: 7.43,
    width: 0.21,
    height: 4.13,
    transform: "translate(-4.03 9.26) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.54,
    y: 35.76,
    width: 0.21,
    height: 4.13,
    transform: "translate(-15.72 37.69) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 37.46,
    y: 35.83,
    width: 0.21,
    height: 4.13,
    transform: "translate(-15.79 37.66) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.27,
    y1: 37.16,
    x2: 32.55,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.94,
    y1: 38.2,
    x2: 31.53,
    y2: 34.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32.52,
    y1: 39.11,
    x2: 30.44,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.02,
    y1: 39.89,
    x2: 29.29,
    y2: 36.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.45,
    y1: 40.52,
    x2: 28.08,
    y2: 36.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.84,
    y1: 41,
    x2: 26.84,
    y2: 36.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.18,
    y1: 41.32,
    x2: 25.57,
    y2: 37.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.5,
    y1: 41.49,
    x2: 24.28,
    y2: 37.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.82,
    y1: 41.5,
    x2: 22.98,
    y2: 37.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.14,
    y1: 41.36,
    x2: 21.69,
    y2: 37.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.48,
    y1: 41.06,
    x2: 20.41,
    y2: 37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.85,
    y1: 40.61,
    x2: 19.17,
    y2: 36.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.28,
    y1: 40,
    x2: 17.96,
    y2: 36.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.77,
    y1: 39.25,
    x2: 16.8,
    y2: 35.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.33,
    y1: 38.36,
    x2: 15.69,
    y2: 34.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.99,
    y1: 37.34,
    x2: 14.66,
    y2: 34.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.74,
    y1: 36.21,
    x2: 13.7,
    y2: 33.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.61,
    y1: 34.96,
    x2: 12.83,
    y2: 32.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.6,
    y1: 33.6,
    x2: 12.05,
    y2: 31.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.73,
    y1: 32.16,
    x2: 11.38,
    y2: 30.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.99,
    y1: 30.64,
    x2: 10.82,
    y2: 28.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.4,
    y1: 29.06,
    x2: 10.36,
    y2: 27.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.96,
    y1: 27.43,
    x2: 10.03,
    y2: 26.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.67,
    y1: 25.76,
    x2: 9.81,
    y2: 25.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.54,
    y1: 24.08,
    x2: 9.71,
    y2: 23.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.57,
    y1: 22.4,
    x2: 9.73,
    y2: 22.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.75,
    y1: 20.72,
    x2: 9.87,
    y2: 21.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.09,
    y1: 19.07,
    x2: 10.13,
    y2: 20.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.58,
    y1: 17.46,
    x2: 10.51,
    y2: 18.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.23,
    y1: 15.9,
    x2: 11,
    y2: 17.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.02,
    y1: 14.4,
    x2: 11.61,
    y2: 16.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.94,
    y1: 12.99,
    x2: 12.32,
    y2: 15.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.99,
    y1: 11.67,
    x2: 13.12,
    y2: 14.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.16,
    y1: 10.46,
    x2: 14.02,
    y2: 13.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.43,
    y1: 9.35,
    x2: 15,
    y2: 12.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.8,
    y1: 8.37,
    x2: 16.06,
    y2: 11.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.26,
    y1: 7.52,
    x2: 17.18,
    y2: 11.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.8,
    y1: 6.82,
    x2: 18.35,
    y2: 10.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.39,
    y1: 6.26,
    x2: 19.58,
    y2: 10.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.04,
    y1: 5.86,
    x2: 20.84,
    y2: 9.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.7,
    y1: 5.61,
    x2: 22.12,
    y2: 9.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 23.39,
    y1: 5.52,
    x2: 23.42,
    y2: 9.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.07,
    y1: 5.59,
    x2: 24.72,
    y2: 9.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.75,
    y1: 5.81,
    x2: 26,
    y2: 9.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.39,
    y1: 6.19,
    x2: 27.27,
    y2: 10.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.99,
    y1: 6.72,
    x2: 28.5,
    y2: 10.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.54,
    y1: 7.41,
    x2: 29.68,
    y2: 11.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.01,
    y1: 8.23,
    x2: 30.81,
    y2: 11.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.4,
    y1: 9.19,
    x2: 31.88,
    y2: 12.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.69,
    y1: 10.27,
    x2: 32.87,
    y2: 13.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.88,
    y1: 11.47,
    x2: 33.79,
    y2: 14.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.95,
    y1: 12.77,
    x2: 34.61,
    y2: 15.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.9,
    y1: 14.17,
    x2: 35.34,
    y2: 16.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.71,
    y1: 15.65,
    x2: 35.96,
    y2: 17.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.38,
    y1: 17.2,
    x2: 36.47,
    y2: 18.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.89,
    y1: 18.8,
    x2: 36.87,
    y2: 19.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.26,
    y1: 20.45,
    x2: 37.15,
    y2: 21.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.47,
    y1: 22.12,
    x2: 37.32,
    y2: 22.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.52,
    y1: 23.81,
    x2: 37.36,
    y2: 23.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.42,
    y1: 25.49,
    x2: 37.28,
    y2: 25.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.16,
    y1: 27.16,
    x2: 37.08,
    y2: 26.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.74,
    y1: 28.8,
    x2: 36.76,
    y2: 27.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.18,
    y1: 30.39,
    x2: 36.32,
    y2: 28.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.46,
    y1: 31.92,
    x2: 35.78,
    y2: 29.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 38.6,
    y1: 33.38,
    x2: 35.12,
    y2: 31.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 37.61,
    y1: 34.74,
    x2: 34.35,
    y2: 32.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.49,
    y1: 36,
    x2: 33.49,
    y2: 33.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 23.56,
    cy: 23.56,
    r: 12.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.97,28.97c-1.68,3.93-5.84,6.52-10.09,6.52-6.08,0-11.39-5.08-11.39-11.45s5.08-11.27,11.3-11.27c4.34,0,8.5,2.51,10.3,6.67h-4.6c-1.56-1.8-3.39-2.89-5.84-2.89-3.95,0-7.11,3.69-7.11,7.56s3.25,7.61,7.26,7.61c2.04,0,3.69-.74,5.49-2.74h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.28,35.05l-5.78-8.35h-.06v8.35h-4.04V13.21h7.41c4.31,0,7.17,3.07,7.17,6.82,0,2.04-1.06,6.08-5.73,6.96l5.93,8.06h-4.9ZM86.12,23.65c2.27,0,3.81-1.21,3.81-3.36s-1.71-3.31-3.81-3.31h-2.69v6.67h2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.77,35.05l-2.33-5.64h-7.82l-2.33,5.64h-4.46l9.09-21.84h3.16l9.15,21.84h-4.46ZM105.51,18.9h-.06l-2.48,6.7h5.02l-2.48-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M138.07,28.97c-1.68,3.93-5.84,6.52-10.09,6.52-6.08,0-11.39-5.08-11.39-11.45s5.08-11.27,11.3-11.27c4.34,0,8.5,2.51,10.3,6.67h-4.6c-1.56-1.8-3.39-2.89-5.84-2.89-3.95,0-7.11,3.69-7.11,7.56s3.25,7.61,7.26,7.61c2.04,0,3.69-.74,5.49-2.74h4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.15,35.05l-6.82-9.59h-.06v9.59h-4.04V13.21h4.04v9.44h.06l6.82-9.44h4.75l-8.23,10.74,8.23,11.1h-4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.39,35.05v-18.06h-4.04v-3.78h12.16v3.78h-4.07v18.06h-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M191.53,35.05v-9.18h-7.82v9.18h-4.04V13.21h4.04v8.88h7.82v-8.88h4.04v21.84h-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.44,35.05V13.21h11.75v3.78h-7.7v5.34h7.38v3.78h-7.38v5.16h7.7v3.78h-11.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M231.14,18.99v-.03c-.12-1.42-.91-2.42-2.45-2.42-1.27,0-2.24.91-2.24,2.21,0,1.42.94,2.24,2.8,2.77,4.6,1.36,6.55,3.42,6.55,6.99,0,4.28-3.1,6.97-7.08,6.97s-6.88-2.74-7.11-6.7h4.25c.21,1.8,1.27,2.92,2.89,2.92s3.01-1.21,3.01-2.77-1.06-2.54-2.8-3.16c-3.45-1.24-6.55-2.21-6.55-6.79,0-3.72,2.95-6.23,6.4-6.23s6.26,2.54,6.46,6.23h-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M253.75,35.05l-2.33-5.64h-7.82l-2.33,5.64h-4.46l9.09-21.84h3.16l9.15,21.84h-4.46ZM247.49,18.9h-.06l-2.48,6.7h5.02l-2.48-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M260.24,35.05V13.21h11.13v3.78h-7.08v5.34h6.76v3.78h-6.76v8.94h-4.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274.41,35.05V13.21h11.75v3.78h-7.7v5.34h7.38v3.78h-7.38v5.16h7.7v3.78h-11.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackTheSafeLogo);
export default __webpack_public_path__ + "static/media/crack-the-safe-logo.066cbeec4ab9efde01a003d3213143aa.svg";
export { ForwardRef as ReactComponent };